// @ts-strict-ignore
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CarlDataType } from 'src/app/core/services/carl/carl-data-type.enum';
import { CarlService } from 'src/app/core/services/carl/carl.service';
import { Route } from 'src/app/routing/route.enum';

import { noop } from '../utils/functions/noop';

@Injectable()
export class KillswitchInterceptor implements HttpInterceptor {
  private carlConfigUrl: string;

  public constructor(
    private readonly router: Router,
    private readonly carlService: CarlService
  ) {
    this.carlService.getUrl(CarlDataType.Configuration).subscribe(url => (this.carlConfigUrl = url));
  }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((response: HttpResponse<unknown>) => {
        if (this.isInterceptConditionFulfilled(request, response)) {
          // TODO: shouldn't we dispatch an action instead in order to get that redirect?
          // when you already thought about this question, you already know the answer...
          this.router.navigate([Route.ErrorPage]).catch(noop);
        }
      })
    );
  }

  private isInterceptConditionFulfilled(request: HttpRequest<unknown>, response: HttpResponse<unknown>): boolean {
    return (
      request.url === this.carlConfigUrl &&
      !!(response?.body as { disableConfiguratorForThisMarket: unknown })?.disableConfiguratorForThisMarket
    );
  }
}
